import { defineStore } from "pinia";
import Services from '@/services/sutting/issuersOldIdentificationCardsServices'
import { mapList, mapIssuerOldIdentificationCard } from '@/helpers/mapFuncs'

export const useIssuersOldIdentificationCardsStore = defineStore("issuersOldIdentificationCards", {
persist: true,
state:()=>({
    issuerOldIdentificationCard: {},
    issuersOldIdentificationCards: [],
}),
getters : {
    getIssuerOldIdentificationCard() {
        return mapIssuerOldIdentificationCard(this.issuerOldIdentificationCard)
    },
    getIssuersOldIdentificationCards() {
        return this.issuersOldIdentificationCards.map(mapIssuerOldIdentificationCard)
    },
    getIssuersOldIdentificationCardsList() {
        return this.issuersOldIdentificationCards.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setIssuerOldIdentificationCard(issuerOldIdentificationCard) {
        this.issuerOldIdentificationCard = issuerOldIdentificationCard
    },
    setIssuersOldIdentificationCards(issuersOldIdentificationCards) {
        this.issuersOldIdentificationCards = issuersOldIdentificationCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setIssuerOldIdentificationCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setIssuersOldIdentificationCards(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.issuersOldIdentificationCards.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.issuersOldIdentificationCards[this.issuersOldIdentificationCards.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.issuersOldIdentificationCards = this.issuersOldIdentificationCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
